import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import { Link } from 'react-router-dom'
import agent from '../agent'
import { withRouter } from 'react-router-dom'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import Nav from './widgets/Nav'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
import {
  MY_DETAIL_PAGE_UNLOADED,
  MY_DETAIL_SUBMITTED,
  SEND_VERIFICATION_EMAIL,
  CHANGE_PASSWORD_SUBMITTED
} from '../constants/actionTypes'

const mapStateToProps = state => ({
  ...state.settings,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: (payload) => {
    dispatch({ type: MY_DETAIL_SUBMITTED, payload })
  },
  onSendVerificationEmail: (payload) => {
    dispatch({ type: SEND_VERIFICATION_EMAIL, payload })
  },
  onUpdatePassword: (payload) => {
    dispatch({ type: CHANGE_PASSWORD_SUBMITTED, payload })
  },
  onUnload: () => {
    dispatch({ type: MY_DETAIL_PAGE_UNLOADED })
  },

})

class Settings extends React.Component {
  constructor() {
    super()
    this.state = {
      firstname: '',
      lastname: '',
      phone: '',
      referral: '',
      password: '',
      confirmPassword: '',
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.updateProfile = (firstname, lastname, email) => ev => {
      ev.preventDefault()
      const payload = agent.Profile.updateProfile(this.props.currentUser.key, firstname, lastname, email)
      this.props.onUpdateProfile(payload)
    }
    this.resendVerificationEmail = () => ev => {
      ev.preventDefault()
      const payload = agent.Profile.sendVerificationEmail(this.props.currentUser.key)
      this.props.onSendVerificationEmail(payload)
    }
    this.updatePassword = (password, confirmPassword) => ev => {
      ev.preventDefault()
      this.setState({ message: '' })
      if (!password || password !== confirmPassword) {
        return
      }
      const payload = agent.Profile.changePassword(this.props.currentUser.key, password)
      this.props.onUpdatePassword(payload)
    }
  }
  componentWillMount() {
    if (!this.props.currentUser) {
      store.dispatch(push("/login"))
    } else {
      Object.assign(this.state, {
        firstname: this.props.currentUser.firstname,
        lastname: this.props.currentUser.lastname,
        email: this.props.currentUser.email,
        referral: this.props.currentUser.referrer_code ? this.props.currentUser.referrer_code : this.props.currentUser.bankreference
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.profile_updated) {
      this.setState({ profile_message: <div className="form-item"><span>{i18n.t('settings.setting_profile_updated_message')}</span></div> })
    } else if (nextProps.emailsent) {
      this.setState({ profile_message: <div className="form-item"><span>{i18n.t('settings.setting_email_sent')}</span></div> })
    } else if (nextProps.password_updated) {
      this.setState({ password_message: <div className="form-item"><span>{i18n.t('settings.setting_password_updated_message')}</span></div> })
    }
  }
  componentWillUnmount() {
    this.props.onUnload()
  }
  render() {
    let user = this.props.currentUser

    if (!user) {
      return (
        <Loading selected={'settings'} currentUser={this.props.currentUser} />
      )
    }
    const firstname = this.state.firstname
    const lastname = this.state.lastname
    const email = this.state.email
    const referral = this.state.referral
    const inProgress = this.props.inProgress
    const waitSpinActive = this.props.waitSpinActive

    const password = this.state.password
    const confirmPassword = this.state.confirmPassword

    return (
      <Translation>
        {
          (t) => (
            <div id="main">
              <Nav selected={'settings'} currentUser={this.props.currentUser} />
              <div id="content">
                <Header />
                <div id="content-clear">
                  <div className="focus-wrap">
                    <div className='box-header'>
                      <h2>{t('settings.home_details_change')}</h2>
                    </div>
                    {this.state.profile_message}
                    {/*
                this.props.currentUser.awaiting_verify_email ?
                  <div className="form-item">
                    <span>
                      {t('authentication.verification_new_email_sent_message')}
                    </span>
                  </div> : null
              */}
                    <div className="form-item">
                      <label>{t('input_label.firstname')}</label>
                      <input type='text' value={firstname} onChange={this.updateState('firstname')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.lastname')}</label>
                      <input type='text' value={lastname} onChange={this.updateState('lastname')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.email')}</label>
                      <input type='text' value={email} onChange={this.updateState('email')} />
                    </div>
                    <ListErrors errors={this.props.profile_errors} />
                    <div className="form-item">
                      <button className='SubmitButton' disabled={inProgress ? 'disabled' : ''}
                        onClick={this.updateProfile(firstname, lastname, email)}>{inProgress ? t('settings.detail_button_progress') : t('settings.detail_button')}
                      </button>
                    </div>
                    {/*(this.props.currentUser.email_verified !== true || this.props.currentUser.awaiting_verify_email) ?
                <div className="form-item">
                  <button className='SubmitButton' onClick={this.resendVerificationEmail()}
                    disabled={waitSpinActive ? 'disabled' : ''}>
                    {waitSpinActive ? t('settings.verify_email_progress') : t('settings.verify_email_button')}
                  </button>
                </div>
                : null
              */}
                  </div>

                  <div className="focus-wrap">
                    <div className='box-header'>
                      <h2>{t('settings.password_title')}</h2>
                    </div>
                    {this.state.password_message}
                    <div className="form-item">
                      <label>{t('input_label.password_new')}</label>
                      <input type="password" value={password} onChange={this.updateState('password')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.password_new_confirm')}</label>
                      <input type="password" value={confirmPassword} onChange={this.updateState('confirmPassword')} />
                    </div>
                    <ListErrors errors={this.props.password_errors} />
                    <div className="form-item">
                      <button className='SubmitButton'
                        disabled={waitSpinActive ? 'disabled' : ''}
                        onClick={this.updatePassword(password, confirmPassword)}>{waitSpinActive ? t('settings.detail_button_progress') : t('settings.password_button')}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </Translation>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings))
